<template>
  <IconSvgBase :class="$style.path" :view-width="20" :view-height="20">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.6665 5.83333C11.6665 4.91417 10.919 4.16667 9.99984 4.16667C9.08067 4.16667 8.33317 4.91417 8.33317 5.83333C8.33317 6.7525 9.08067 7.5 9.99984 7.5C10.919 7.5 11.6665 6.7525 11.6665 5.83333ZM13.3332 5.83333C13.3332 7.67167 11.8382 9.16667 9.99984 9.16667C8.1615 9.16667 6.6665 7.67167 6.6665 5.83333C6.6665 3.995 8.1615 2.5 9.99984 2.5C11.8382 2.5 13.3332 3.995 13.3332 5.83333ZM4.1665 16.6667C4.1665 13.45 6.784 10.8333 9.99984 10.8333C13.2157 10.8333 15.8332 13.45 15.8332 16.6667C15.8332 17.1267 15.4607 17.5 14.9998 17.5C14.539 17.5 14.1665 17.1267 14.1665 16.6667C14.1665 14.3692 12.2973 12.5 9.99984 12.5C7.70234 12.5 5.83317 14.3692 5.83317 16.6667C5.83317 17.1267 5.46067 17.5 4.99984 17.5C4.539 17.5 4.1665 17.1267 4.1665 16.6667Z"
    />
  </IconSvgBase>
</template>

<script setup lang="ts">
import IconSvgBase from '@/components/icons/IconSvgBase.vue'
</script>

<style lang="scss" module>
.path {
  width: 1em;
  height: 1em;
}
</style>
